// removed by extract-text-webpack-plugin
module.exports = {"EditRole":"EditRole--3VfAq","RoleName":"RoleName--2WT3Y","Permissions":"Permissions--1kcCg","Submit":"Submit--2W1nv"};